import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import {_AuthenticationService} from '../services/auth.service';

declare var $: any, dump: any, showSuccessMessage:any, showErrorMessage: any;

@Injectable()

export class _RuleService {

  constructor(private http: HttpClient, private auth: _AuthenticationService) { }

  GetRule(organizationId){
      return this.http.get('/ajax/rules/' + organizationId).toPromise().then((result) => {
          return result;
      });
  }

  UpdateRule(rule){
      return this.http.put('/ajax/rules', [ rule ]).toPromise().then((result) => {
          return result;
      });
  }

}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/ng1-services/rule.service.ts